module.exports = __webpack_public_path__ + "img/Orange_Mixed.d272f670.png";